import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "container-fluid h-100" };
const _hoisted_2 = { class: "row h-100" };
const _hoisted_3 = { class: "col-5 h-100 border p-0" };
const _hoisted_4 = { class: "col-7 p-0 ps-2" };
const _hoisted_5 = ["src"];
const _hoisted_6 = {
    key: 1,
    class: "w-100 h-100 bg-light"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_ticket__item = _resolveComponent("g-ticket__item");
    const _component_g_monaco_editor = _resolveComponent("g-monaco-editor");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_g_ticket__item, {
                    "context-Id": _ctx.contextId,
                    "item-Id": _ctx.itemId
                }, null, 8, ["context-Id", "item-Id"])
            ]),
            _createElementVNode("div", _hoisted_4, [
                (_ctx._viewerType === 'pdf')
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 0,
                        src: _ctx._viewerUrl,
                        frameborder: "0",
                        class: "border w-100 h-100"
                    }, null, 8, _hoisted_5))
                    : (_ctx._viewerType === 'monaco')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_g_monaco_editor, {
                                language: _ctx._viewerLanguage,
                                value: _ctx._viewerData
                            }, null, 8, ["language", "value"])
                        ]))
                        : _createCommentVNode("", true)
            ])
        ])
    ]));
}
